export default "__VITE_PUBLIC_ASSET__f890f4f4__"